import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { getAllExamTypes } from "./../../actions/commonActions";
import { getUserSubscription, getUserSubscriptionList } from "./../../actions/subscriptionActions";
import Loader from "../Loader";
import { confirmAlert } from "react-confirm-alert";
import { USER_SUBSCRIPTION_RESET } from "../../constants/subscriptionConstants";
import { examLogoUrl, placeholderImageUrl } from "../../utils/assets";
import { subscriptionMatchesExam } from "../../utils/examSubscription";

const Exams = ({ history }) => {
    const alert = useAlert();
    const dispatch = useDispatch();

    const [examType, setExamType] = useState("");
    const [examId, setExamId] = useState("");
    const [examName, setExamName] = useState("");
    const [examSlug, setExamSlug] = useState("");
    const [examLogo, setExamLogo] = useState("");
    const [maximumSubjects, setMaximumSubjects] = useState(0);
    const [examationType, setExamationType] = useState("");
    const { user, isAuthenticated } = useSelector((state) => state.auth);
    const { userSubscription, userSubscriptionList } = useSelector((state) => state.examSubscriptions);

    useEffect(() => {
        dispatch(getAllExamTypes());
        dispatch({
              type: USER_SUBSCRIPTION_RESET
            });
        setExamType("");
        setExamId("");
        setExamName("");
        setExamSlug("");
        setExamLogo("");
    }, [dispatch, isAuthenticated, user]);

    useEffect(() => {
        if (user?._id) {
            dispatch(getUserSubscriptionList(user._id));
        }
    }, [dispatch, user?._id]);

    useEffect(() => {
        if (!examType || !user?._id) {
            return;
        }

        dispatch(getUserSubscription(user._id, examType));
    }, [dispatch, examType, user?._id]);

    useEffect(() => {
        // Scroll to the top when the component mounts
        window.scrollTo(0, 0);
    }, []);



    const { allExamTypes, eloading } = useSelector((state) => state.commonExams);

    const onChange = (e) => {        
        setExamType(e.target.value);
        setExamName(e.target.dataset.name);
        setExamSlug(e.target.dataset.slug);
        localStorage.setItem("logo", e.target.dataset.logo)
        setExamLogo(e.target.dataset.logo);
        setMaximumSubjects(e.target.dataset.subjectcount);
        localStorage.setItem('maximumSubjects', e.target.dataset.subjectcount)
        localStorage.setItem("examinationType", e.target.dataset.type);
        setExamationType(e.target.dataset.type);
        dispatch({ type: USER_SUBSCRIPTION_RESET });
        if (e.target.dataset.slug !== 'post-utme' && user?._id) {
            dispatch(getUserSubscription(user._id, e.target.value));
        }
    };
    
    useEffect(() => {
        ['RegSubjects', 'examId', 'examName', 'examSlug', 'logo', 'maximumSubjects', 'examinationType', 'userSubscription'].forEach(key => localStorage.removeItem(key));
    }, [])

    const activeSubscriptions = Array.isArray(userSubscriptionList)
        ? userSubscriptionList.filter((entry) => entry?.status !== false)
        : [];

    const hasActiveSubscriptionForExam = (examId) =>
        activeSubscriptions.some((entry) => subscriptionMatchesExam(entry, examId));

    const submitHandler = (e) => {
        e.preventDefault();
        if (examType !== "" && examType !== null && examType !== undefined) {
            localStorage.setItem("examId", examType);
            localStorage.setItem("examSlug", examSlug);
            localStorage.setItem("examName", examName);
            localStorage.setItem("logo", examLogo)

            const matchedSubscription =
                userSubscription && subscriptionMatchesExam(userSubscription, examType)
                    ? userSubscription
                    : activeSubscriptions.find((entry) => subscriptionMatchesExam(entry, examType)) || null;
            
            if (matchedSubscription) {
                localStorage.setItem("userSubscription", matchedSubscription._id);
                if (examName === "JSCE (BECE)") {
                    history.push(`/course-subjects`);
                } else {
                    history.push(`/categories`);
                }
            } else if (examName === 'POST UTME') {
                history.push(`/university`);
            } else {
                history.push(`/subscription-plans`);
            }
        } else {
            alert.error("Please select exam type to proceed.");
            return false;
        }
    };


    return (
        <Fragment>
            <section
                className="page-banner-sec text-center"
                style={{
                    backgroundImage: `url("../assets/frontend/img/about-banner.jpg")`,
                }}
            >
                <div className="container">
                    <ul className="clearfix paginations-cust">
                        <li>
                            <a href="#!">Home</a>
                        </li>
                        <li>
                            <a href="#!">Subscription</a>
                        </li>
                    </ul>
                    <h1>Exam Type</h1>
                </div>
            </section>

            <section className="subscription-page">
                <div className="container">
                    <div className="end-plan">
                        <h1>Select Exam Type</h1>
                    </div>
                    <div className="custom-radios-plan examtype-spaner">
                        {eloading ? (
                            <Loader />
                        ) : (
                            <div className="wrapper clearfix">
                                {allExamTypes !== undefined && allExamTypes.length > 0
                                    ? allExamTypes?.map((item, key) => {
                                        const indexId = key + 1;
                                        return (
                                            <Fragment key={indexId}>
                                                <input
                                                    type="radio"
                                                    name="select"
                                                    id={`option-${indexId}`}
                                                    value={item._id}
                                                    data-name={item.title}
                                                    data-slug={item.slug}
                                                    checked={examType === item._id ? true : false}
                                                    data-type={item.examType}
                                                    data-subjectcount={item.maximumSubjects}
                                                    data-logo={item.logo}
                                                    onClick={onChange}
                                                    onChange={onChange}
                                                    disabled={!item?.status}
                                                />

                                                <label
                                                    htmlFor={`option-${indexId}`}
                                                    className={`option option-${indexId}`}
                                                >
                                                    <div className="dot"></div>
                                                    <div className="extype">
                                                        <img
                                                            src={examLogoUrl(item.logo)}
                                                            alt="exam-logo"
                                                            onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = placeholderImageUrl(); }}
                                                        />
                                                    </div>
                                                    <span>{item.title}</span>
                                                    {hasActiveSubscriptionForExam(item._id) && (
                                                        <p style={{ fontSize: "12px", marginTop: "6px" }}>Active plan</p>
                                                    )}
                                                    <p><a style={{ color: examType === item._id ? "white" : "#31B0E7" }} href={item?.video_link || "#"} target={item?.video_link ? "_blank" : ""}>Show Video Guide</a></p>
                                                    {!item?.status && (<p>Coming Soon</p>)}
                                                </label>

                                            </Fragment>
                                        );
                                    })
                                    : ""}
                            </div>
                        )}
                    </div>
                    <div className="next-prev-steps text-center">

                        <button
                            type="submit"
                            className="chose-more"
                            onClick={submitHandler}
                        >
                            Next <i className="fas fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default Exams;
